import { match } from "ts-pattern";

import { dayjs } from "@thalamos/common";

import type { IncidentType } from "../../types/incidentType.js";
import { IncidentTypeSchema } from "../../types/incidentType.js";

/**
 * Names the form for the statutory power it was completed under. Officers file
 * these by hand, so the name has to say which Act applies.
 */
export function getIncidentFormPdfName(
  incidentType: IncidentType | undefined,
): string {
  return (
    match(incidentType)
      .with(IncidentTypeSchema.enum.section136, () => "Section 136 (MHA) Form")
      .with(
        IncidentTypeSchema.enum.mentalCapacityAct,
        () => "Mental Capacity Act (MCA) Form",
      )
      // Left unqualified when no statutory power applies, or when the type
      // could not be read — better than naming the wrong Act on a filed form.
      .with(
        IncidentTypeSchema.enum.voluntary,
        IncidentTypeSchema.enum.other,
        undefined,
        () => "Form",
      )
      .exhaustive()
  );
}

/** The date stamp every downloaded form's filename carries. */
export function formatFormPdfFilenameDate(date: Date): string {
  return dayjs(date).format("DDMMYYYY");
}

export function buildIncidentFormPdfFilename({
  incidentType,
  date,
}: {
  incidentType: IncidentType | undefined;
  date: Date;
}): string {
  return `${getIncidentFormPdfName(incidentType)} ${formatFormPdfFilenameDate(date)}.pdf`;
}
